export enum IncidenceDateOption {
    DATE_CREATION = 1,          // Fecha de creación
    DATE_PLANIFICATION = 2,     // Fecha de planificación
    DATE_EXECUTION = 3          // Fecha de ejecución
}